import $ from 'jquery';

export default () => {
  navigationAddActive();

  function navigationAddActive() {
    var navLinks = $('.main-header .navbar-nav .nav-link');
    var dropdownNavLinks = $('.main-header .sub-menu .sub-menu-item');

    let addedActive = false;
    navLinks.each(function () {
      let link = $(this).attr('href');
      if (window.location.pathname.indexOf(link) != -1 && link != '/' && link != '/ar') {
        $(this).addClass('active');
        addedActive = true;
      } else if ((window.location.pathname == '/' && link == '/') || (window.location.pathname == '/ar/' && link == '/ar')) {
        $(this).addClass('active');
        addedActive = true;
      }
    });

    if (addedActive == false) {
      dropdownNavLinks.each(function () {
        let link = $(this).attr('href');
        if (window.location.pathname.indexOf(link) != -1 && link != '/') {
          $(this).parent().parent().find('.submenu-toggle').addClass('active');
        }
      });
    }
  }
  $('.js-toggle-submenu').on('click', function () {
    let $this = $(this);
    let subMenuCont = $this.parents('.sub-menu-cont').toggleClass('opened');
  });

  // toogle mobilemenu
  $('.js-toogle-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.js-fixed-navbar').toggleClass('visible');
    if($('.js-fixed-navbar').hasClass('visible')){
      let offset = 1;
      $.each($('.nav-item'), function(o,i){
           let delay = parseFloat(offset + `.${o}`);
          $(this).css({'transition-delay': delay+'s'});
      });
    } else {
      let offset = 0;
      for (let i = $('.nav-item').length; i >= 0; i-=1) {
        let delay = parseFloat(offset + `.${i}`);
        let element = $($('.nav-item').get(i))
        element.css({'transition-delay': delay+'s'});        
      }

    }

    $('body').toggleClass('mobile-menu-open');
    $(this).attr('aria-expanded', $('.js-fixed-navbar').hasClass('visible'))
  });
};
